/**
 * Programmatic API-user management. The machine credentials a customer uses for
 * third-party API access (`api-users/`): list, create, enable/disable, key
 * reset, and delete.
 *
 * Contains:
 * - fetchApiUsers: list API users
 * - createApiUser: provision a new API user
 * - toggleApiUser: enable or disable an API user
 * - resetApiUser: reset an API user's key
 * - deleteApiUser: remove an API user
 */
import apiClient from '@sophocles/http-common';

export const fetchApiUsers = customerId =>
  apiClient.get('api-users/', { params: { customer: customerId } }).then(res => res.data.results);

export const createApiUser = (firstName, customerId) =>
  apiClient.post('api-users/', { first_name: firstName, customer: customerId }).then(res => res.data);

export const toggleApiUser = (userId, isActive) =>
  apiClient.patch(`api-users/${userId}/`, { is_active: isActive }).then(res => res.data);

export const resetApiUser = userId => apiClient.patch(`api-users/${userId}/reset/`).then(res => res.data);

export const deleteApiUser = userId => apiClient.delete(`api-users/${userId}/`);
